import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-crema py-16 md:py-24 px-4" data-id="element-75">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center border-t-8 border-confianza relative mt-8" data-id="element-76">
        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-lg" data-id="element-77">
          <div className="bg-confianza rounded-full p-4" data-id="element-78">
            <ShieldCheck className="w-12 h-12 text-white" data-id="element-79" />
          </div>
        </div>

        <h2 className="text-[28px] md:text-[36px] font-playfair font-bold text-marron mt-8 mb-4" data-id="element-80">
          🛡️ GARANTÍA TOTAL 30 DÍAS
        </h2>

        <div className="inline-block bg-confianza/10 text-confianza font-bold px-4 py-2 rounded-full mb-6 text-sm uppercase tracking-wider" data-id="element-81">
          Tu inversión está completamente protegida
        </div>

        <p className="text-lg text-carbon mb-6 leading-relaxed" data-id="element-82">
          Aplica el protocolo durante 30 días. Si no notas cambios en
          luminosidad, textura o firmeza de tu piel, te devuelvo cada centavo.
          Sin formularios. Sin preguntas. Sin drama.
        </p>

        <p className="text-xl font-bold text-marron" data-id="element-83">
          El riesgo es 100% mío. El resultado es 100% tuyo.
        </p>
      </div>
    </section>;
}